/* tslint:disable */

declare var Object: any;
export interface OpenErpServiceInterface {
  "id"?: string;
}

export class OpenErpService implements OpenErpServiceInterface {
  "id": string;
  constructor(data?: OpenErpServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `OpenErpService`.
   */
  public static getModelName() {
    return "OpenErpService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of OpenErpService for dynamic purposes.
  **/
  public static factory(data: OpenErpServiceInterface): OpenErpService{
    return new OpenErpService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'OpenErpService',
      plural: 'OpenErpService',
      path: 'OpenErpService',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/OpenErpService.ts